import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import LeavePlan from "..";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../Constants";
import { Validation } from "../../Validation";
import ProRate from "../Common/ProRate";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

const ParentState = {
  leavename: "",
  leaveid: null,
  maxmonthhour: 1,
  maxonedayhour: 1,
  minhour: 0,
  EmploymentTypeList: [],
  employeetypeids: null,
  accuralfrequencytype: 1,
  isfurtureappallowed: false,
  minleavecountforapp: 0,
  notifyinadvanceday: 0,
  notifynotbeforeday: 0,
  apppastday: 0,
  ispastappallowed: false,
  isoverutilizationallowed: null,
  iscarryforwardallowed: false,
  carryforwardunusedperc: null,
  carryforwardunused: null,
  carryForwardType: [
    {
      displayname: "Fixed Number",
      displayvalue: 2,
    },
    {
      displayname: "Percentage",
      displayvalue: 3,
    },
  ],
  forwardtypeid: {
    displayname: null,
    displayvalue: null,
  },
  approvaltypeid: 1,
  // carryforwardunusedperc: 0,
  // carryforwardunused: 0,
};

class HourlyLeave extends React.Component {
  constructor(props) {
    super(props);
    console.log("props: ", props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid || 3,
    };
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    console.log("he");
    this.SetValues(this.props);
    this.getEmploymentType();
    this.props.ChangeLanguage("hourlyleave,navigation");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.validateNext,
    });
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  componentWillReceiveProps(props) {
    if (
      !get(
        props,
        `InitLeavesPolicy.policy[${props.ParentIndex}].isprorate`,
        true,
      ) &&
      this.state.accuralfrequencytype != 2
    ) {
      this.handleChange("accuralfrequencytype", 2);
    }
    this.props.onRef({
      onNext: this.validateNext,
    });
    if (this.state.ParentIndex != props.ParentIndex) {
      console.log("here1");
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const policyPlan = props.InitLeavesPolicy.policy[ParentIndex];
      const maxmonthhour = policyPlan.maxmonthhour || 1;
      const maxonedayhour = policyPlan.maxonedayhour || 1;
      const minhour = policyPlan.minhour || 0;
      const forwardtypeidtemp = policyPlan.forwardtypeid;
      let forwardtypeid = {
        displayname: null,
        displayvalue: null,
      };
      if (policyPlan.iscarryforwardallowed) {
        if (forwardtypeidtemp == 1) {
          forwardtypeid = { displayname: "All", displayvalue: 1 };
        } else {
          forwardtypeid = this.state.carryForwardType.find(
            (x) => x.displayvalue == forwardtypeidtemp,
          );
        }
      }
      this.setState({
        leavetypeid: props.leavetypeid,
        ParentIndex,
        leavename: policyPlan.leavename,
        maxmonthhour,
        maxonedayhour,
        minhour,
        accuralfrequencytype: policyPlan.accuralfrequencytype,
        isfurtureappallowed: policyPlan.isfurtureappallowed,
        minleavecountforapp: policyPlan.minleavecountforapp,
        notifyinadvanceday: policyPlan.notifyinadvanceday,
        notifynotbeforeday: policyPlan.notifynotbeforeday,
        apppastday: policyPlan.apppastday,
        ispastappallowed: policyPlan.ispastappallowed,
        isoverutilizationallowed: policyPlan.isoverutilizationallowed,
        iscarryforwardallowed: policyPlan.iscarryforwardallowed,
        carryforwardunusedperc: policyPlan.carryforwardunusedperc,
        carryforwardunused: policyPlan.carryforwardunused,
        forwardtypeid,
        approvaltypeid: policyPlan.approvaltypeid,
      });
    } else {
      const parentIndex = props.ParentIndex || 0;
      const name = get(props, `InitLeavesPolicy.details[${parentIndex}]`, "");
      this.setState(
        { ...ParentState, leavename: name && get(name, "leavetypename", "") },
        () => this.getEmploymentType(),
      );
    }
  }

  getEmploymentType() {
    instance.get(`/superuser/getmastercode/EmploymentType`).then(
      (result) => {
        const policyDet =
          this.props.InitLeavesPolicy.policy[this.state.ParentIndex];
        const EmploymentTypeList = result.data.result;
        if (EmploymentTypeList.length > 0) {
          EmploymentTypeList.unshift({ displayname: "All", displayvalue: 0 });
        }
        let ids = null;
        if (policyDet) {
          ids = policyDet.employeetypeids;
          ids = ids && ids.split(",");
        }
        this.setState(
          {
            EmploymentTypeList,
            // employeetypeids: policyDet ? typeof policyDet.employeetypeids === 'string' ? JSON.parse(policyDet.employeetypeids) : policyDet.employeetypeids : null
            employeetypeids: ids,
          },
          () => {
            const { employeetypeids } = this.state;
            const employeetype = [];
            if (employeetypeids) {
              // eslint-disable-next-line no-unused-vars
              for (const id of employeetypeids) {
                const filterObj = this.state.EmploymentTypeList.find(
                  (x) => x.displayvalue == id,
                );
                employeetype.push(filterObj);
              }
            }
            this.setState({ employeetype });
          },
        );
      },
      (error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      },
    );
  }

  validateNext = () => {
    const [isError, errorMessage] = Validation(
      this.state.leavetypeid,
      this.state.ParentIndex,
    );
    if (this.state.forwardtypeid.displayvalue) {
      if (this.state.forwardtypeid.displayvalue == 2) {
        if (
          this.state.carryforwardunused == 0
          // || this.state.carryforwardunused == "" ||
          // this.state.carryforwardunused == null
        ) {
          this.props.enqueueSnackbar("Please enter carry forward value", {
            variant: "error",
          });
          return;
        }
      } else if (this.state.forwardtypeid.displayvalue == 3) {
        if (
          this.state.carryforwardunusedperc == 0
          // || this.state.carryforwardunusedperc == "" ||
          // this.state.carryforwardunusedperc == null
        ) {
          this.props.enqueueSnackbar("Please enter percentage", {
            variant: "error",
          });
          return;
        }
      }
    }
    if (!isError) {
      this.props.click();
    } else {
      this.props.enqueueSnackbar(errorMessage, { variant: "error" });
    }
  };

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language.hourlyleave
        ? this.props.Language.hourlyleave[key]
        : "",
    });
  };

  checkUnique() {
    const { InitLeavesPolicy, enqueueSnackbar } = this.props;
    const { ParentIndex, leavename } = this.state;
    if (leavename || leavename != "") {
      if (
        leavename.includes("employeename") ||
        leavename.includes("employeecode") ||
        leavename.includes("designation") ||
        leavename.includes("department") ||
        leavename.includes("businessunit")
      ) {
        enqueueSnackbar("Please enter valid leave name", {
          variant: "error",
        });
        this.setState({ notUnique: true }, () => {
          if (
            this.props.InitLeavesPolicy.policy[ParentIndex] &&
            this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
          ) {
            this.UpdateReducer();
          }
        });
      } else if (
        this.props.InitLeavesPolicy.policy[ParentIndex] &&
        this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
      ) {
        this.UpdateReducer();
      } else {
        instance
          .post("/leaves/uniqueleavename", {
            leavename,
            leavetypeid: InitLeavesPolicy.details[ParentIndex].leavetypeid,
            leavecategoryid:
              InitLeavesPolicy.details[ParentIndex].leavecategoryid,
            leaveid: this.props.InitLeavesPolicy.policy[ParentIndex]
              ? this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
              : null,
          })
          .then(() => {
            this.setState({ notUnique: false }, () => this.UpdateReducer());
          })
          .catch((error) => {
            this.setState({ notUnique: true });
            enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              {
                variant: "error",
              },
            );
          });
      }
    } else {
      this.setState({ notUnique: true }, () => {
        if (
          this.props.InitLeavesPolicy.policy[ParentIndex] &&
          this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
        ) {
          this.UpdateReducer();
        }
      });
    }
  }

  onNameChange(event) {
    this.setState({ leavename: event.target.value });
    if (this.props.ChangeSteppername) {
      this.props.ChangeSteppername(event.target.value, this.props.ParentIndex);
    }
  }

  handleChange = (name, ...arg) => {
    switch (name) {
      case "approvaltypeid":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "forwardtypeid":
        this.setState(
          {
            [name]: arg[0],
            carryforwardunusedperc: 0,
            carryforwardunused: 0,
            Selectedforwardtypeid: { displayname: null, displayvalue: null },
          },
          () => this.UpdateReducer(),
        );
        break;
      case "employeetype":
        {
          let filterObj =
            arg[0] && arg[0].findIndex((x) => x.displayvalue == 0);
          if (filterObj != null && filterObj >= 0) {
            filterObj = this.state.EmploymentTypeList.filter(
              (x) => x.displayvalue != 0,
            );
            this.setState({ [name]: filterObj }, () => {
              this.multiOptions(name, filterObj);
            });
          } else {
            this.setState(
              { [name]: arg[0] && arg.length > 0 ? arg[0] : [] },
              () => {
                this.multiOptions(name, arg[0] && arg.length > 0 ? arg[0] : []);
              },
            );
          }
        }
        break;
      case "accuralfrequencytype":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "isfurtureappallowed":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "ispastappallowed":
        this.setState({ [name]: arg[0], apppastday: 0 }, () => {
          this.UpdateReducer();
        });
        break;
      case "isoverutilizationallowed":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "iscarryforwardallowed":
        this.setState(
          {
            [name]: arg[0],
            forwardtypeid: { displayname: null, displayvalue: null },
            carryforwardunusedperc: 0,
            carryforwardunused: 0,
          },
          () => {
            if (this.state.iscarryforwardallowed) {
              this.setState(
                { forwardtypeid: { displayname: "All", displayvalue: 1 } },
                () => this.UpdateReducer(),
              );
            }
            this.UpdateReducer();
          },
        );
        break;
      default:
    }
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (Number(event.target.value) > Number(max)) {
        value = Number(this.state[name]);
      } else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  multiOptions(name, arg) {
    const obj = [];
    // eslint-disable-next-line no-unused-vars
    for (const val of arg) {
      obj.push(val.displayvalue);
    }
    switch (name) {
      case "employeetype":
        this.setState({ employeetypeids: obj }, () => this.UpdateReducer());
        break;
      default:
        break;
    }
  }

  UpdateReducer = () => {
    const { ParentIndex, leavename } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      leavename,
      leavetypeid: this.state.leavetypeid,
      maxmonthhour: this.state.maxmonthhour,
      maxonedayhour: this.state.maxonedayhour,
      minhour: this.state.minhour,
      employeetypeids: this.state.employeetypeids
        ? this.state.employeetypeids.join()
        : this.state.employeetypeids,
      accuralfrequencytype: this.state.accuralfrequencytype,
      isfurtureappallowed: this.state.isfurtureappallowed,
      apppastday: this.state.apppastday,
      ispastappallowed: this.state.ispastappallowed,
      isoverutilizationallowed: this.state.isoverutilizationallowed,
      iscarryforwardallowed: this.state.iscarryforwardallowed,
      forwardtypeid: this.state.forwardtypeid.displayvalue,
      carryforwardunusedperc: this.state.carryforwardunusedperc,
      carryforwardunused: this.state.carryforwardunused,
      approvaltypeid: this.state.approvaltypeid,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  RenderCarryForward = () => (
    <div className="inner-wrapper margin-top-20 opaque">
      <p className="form-main-header">
        <FormattedMessage id="LbCarryForward" defaultMessage="Carry Forward" />
      </p>
      <p className="depedent-select-list-head">
        <FormattedMessage
          id="LbHowDoWeHandle"
          defaultMessage="How do we handle unused leave balance, at the end of a month? "
        />
      </p>
      <div
        className="depedent-select-list"
        onClick={() => this.handleChange("iscarryforwardallowed", false)}
        aria-expanded={this.state.iscarryforwardallowed != true}
      >
        <span>
          {" "}
          <FormattedMessage
            id="LbDontAllowCarryForward"
            defaultMessage="Don't do anything, let the hourly leave balance lapse"
          />{" "}
        </span>
        {!this.state.iscarryforwardallowed ? (
          <span className="floatright">
            {" "}
            <img src={CheckImg} height="20" />{" "}
          </span>
        ) : (
          <span className="not-selected " />
        )}
      </div>
      <div
        className="depedent-select-list"
        onClick={() => this.handleChange("iscarryforwardallowed", true)}
        aria-expanded={this.state.iscarryforwardallowed == true}
      >
        <span>
          {" "}
          <FormattedMessage
            id="LbAllowCarryForward"
            defaultMessage="Carry forward"
          />{" "}
        </span>
        {this.state.iscarryforwardallowed ? (
          <span className="floatright">
            {" "}
            <img src={CheckImg} height="20" />{" "}
          </span>
        ) : (
          <span className="not-selected " />
        )}
      </div>
      <div className="et-level2">
        <Collapse
          in={this.state.iscarryforwardallowed}
          timeout={2}
          unmountOnExit
          className="padding30 overflow-initial"
        >
          <div
            className="depedent-select-list"
            onClick={() =>
              this.handleChange("forwardtypeid", {
                displayname: "All",
                displayvalue: 1,
              })
            }
            aria-expanded={this.state.forwardtypeid == 1}
          >
            <span>
              <FormattedMessage
                id="__LbCarryForwardAllUnused"
                defaultMessage="Carry forward all unused leaves to the next cycle"
              />
            </span>
            {this.state.forwardtypeid.displayvalue == 1 ? (
              <span className="floatright">
                <img src={CheckImg} height="20" />
              </span>
            ) : (
              <span className="not-selected " />
            )}
          </div>
          <div
            className="depedent-select-list"
            onClick={() =>
              this.handleChange("forwardtypeid", {
                displayname: "Fixed",
                displayvalue: 2,
              })
            }
            aria-expanded={this.state.forwardtypeid.displayvalue != 1}
          >
            <span>
              <FormattedMessage
                id="LbCarryForwardAllUnused"
                defaultMessage="Carry forward only a "
              />
            </span>
            {this.state.forwardtypeid.displayvalue != 1 ? (
              <span className="floatright">
                <img src={CheckImg} height="20" />
              </span>
            ) : (
              <span className="not-selected " />
            )}
          </div>
          <div className="et-level3">
            <Collapse
              in={
                this.state.iscarryforwardallowed &&
                this.state.forwardtypeid.displayvalue != 1
              }
              timeout={2}
              unmountOnExit
              className="padding30 overflow-initial"
            >
              <p className="t-14">
                <FormattedMessage
                  id="LbAllowCarryForward"
                  defaultMessage="Carry forward only a "
                />
              </p>
              <span className="width200p">
                <Select
                  class="form-control"
                  autofocus
                  placeholder="Select Type"
                  options={this.state.carryForwardType}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.handleChange.bind(this, "forwardtypeid")}
                  value={this.state.forwardtypeid}
                  isDisabled={!this.state.iscarryforwardallowed}
                />
              </span>
              <InputValues
                min="1"
                max={this.state.forwardtypeid.displayvalue == 2 ? 24 : 99}
                field={
                  this.state.forwardtypeid.displayvalue == 2
                    ? "carryforwardunused"
                    : "carryforwardunusedperc"
                }
                onChange={this.CommonNumberChange.bind(
                  this,
                  this.state.forwardtypeid.displayvalue == 2
                    ? "carryforwardunused"
                    : "carryforwardunusedperc",
                  99,
                )}
                value={
                  this.state.forwardtypeid.displayvalue == 2
                    ? this.state.carryforwardunused
                    : this.state.carryforwardunusedperc
                }
                defaultvalue={
                  this.state.forwardtypeid.displayvalue == 2
                    ? this.state.carryforwardunused
                    : this.state.carryforwardunusedperc
                }
              />
              {this.state.carryforwardunusedperc != 0 && <span>% </span>}
              <span>
                <FormattedMessage
                  id="LbLeaveHours"
                  defaultMessage="leave hours"
                />
              </span>

              <ul className="padding16 padding-bottom-0 margin-bottom-0">
                <li>
                  <span className="t-14">
                    <FormattedMessage
                      id="LbRemainingLeaves"
                      defaultMessage="Note: Remaining leaves will be discarded/lapsed, if any"
                    />
                  </span>
                </li>
              </ul>
            </Collapse>
          </div>
        </Collapse>
      </div>
    </div>
  );

  render() {
    const { InitLeavesPolicy } = this.props;
    const language = this.props.Language.hourlyleave;
    const isprorate = get(
      this.props,
      `InitLeavesPolicy.policy[${this.props.ParentIndex}].isprorate`,
      true,
    );
    return (
      <IntlProvider locale="en" messages={language}>
        <div
          className={classNames(
            InitLeavesPolicy.isviewmode
              ? "disable-leavepolicy padding-bottom-30 leave_policy_form"
              : "padding-bottom-30 leave_policy_form",
          )}
        >
          {/* <div className="inner-wrapper opaque">
                        Hourly Leaves
                    </div> */}
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              <div className="inner-wrapper opaque">
                <p className="form-main-header">
                  <FormattedMessage
                    id="LbHourlyLeaveName"
                    defaultMessage="Let's give this hourly leave a name"
                  />
                </p>
                <div className="form-group">
                  <div>
                    <input
                      type="text"
                      className="form-control"
                      autoFocus
                      placeholder="Hourly Leave Name"
                      maxLength={50}
                      onChange={this.onNameChange.bind(this)}
                      value={this.state.leavename}
                      onBlur={this.checkUnique.bind(this)}
                    />
                    <br />
                    {this.state.notUnique ? (
                      <span className="caption-error leave-policy-error">
                        *Please select a unique name
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="inner-wrapper opaque">
                <p className="form-sub-header">
                  <FormattedMessage
                    id="LbMaximumHoursPerMonth"
                    defaultMessage="Maximum hours allocated per month"
                  />
                </p>
                <p>
                  <InputValues
                    min="1"
                    max="100"
                    field="maxmonthhour"
                    onChange={this.CommonNumberChange.bind(
                      this,
                      "maxmonthhour",
                      100,
                    )}
                    value={this.state.maxmonthhour}
                    defaultvalue={1}
                  />
                </p>
              </div>

              <div className="inner-wrapper opaque">
                <p className="form-main-header">
                  <FormattedMessage
                    id="LbWhoHowWhen"
                    defaultMessage="Who, How & When (Calculations & Disbursal)"
                  />
                </p>
                <p className="form-sub-header">
                  <FormattedMessage
                    id="LbWhocanAvail"
                    defaultMessage="Who can avail this leave balance?"
                  />
                </p>
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbEmploymentType"
                    defaultMessage="Employment Type"
                  />
                </p>
                <div className="margin-bottom-20">
                  <Select
                    className="form-control width58"
                    autofocus
                    placeholder="Select Employment Type"
                    isMulti
                    options={this.state.EmploymentTypeList}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.handleChange.bind(this, "employeetype")}
                    value={this.state.employeetype}
                  />
                </div>
              </div>
              <ProRate
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              <div className="inner-wrapper margin-top-20 opaque">
                <p className="form-sub-header">
                  <FormattedMessage
                    id="LbWhenWillBeLeaveBalance"
                    defaultMessage="When will the leave balance be available for employees to use?"
                  />
                </p>
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbDisbursalAccrual"
                    defaultMessage="Disbursal/Accrual of leave credit"
                  />
                </p>
                {/* <div className="depedent-select-list" aria-expanded={true}>
                                    <span>
                                        <FormattedMessage id="LbDisbursalAccrual" defaultMessage="Disbursal/Accrual of leave credit" />
                                    </span>
                                    <span className="floatright">
                                        <img src={CheckImg} height="20" />
                                    </span>
                                </div> */}
                {/* <div className="et-level2"> */}
                <div
                  onClick={() => this.handleChange("accuralfrequencytype", 1)}
                  className={`depedent-select-list ${
                    !isprorate ? "div-disabled bg-color-f4f4f4" : ""
                  }`}
                  // isDisabled={!get(this.props, `InitLeavesPolicy.policy[${this.props.ParentIndex}].isprorate`, true)}
                  aria-expanded={this.state.accuralfrequencytype == 1}
                >
                  <span>
                    <FormattedMessage
                      id="LbLeaveBalanceBeginingMonth"
                      defaultMessage="Leave balance will be accrued (at the beginning of month)"
                    />
                  </span>
                  {this.state.accuralfrequencytype == "1" ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("accuralfrequencytype", 2)}
                  aria-expanded={this.state.accuralfrequencytype == 2}
                >
                  <span>
                    <FormattedMessage
                      id="LbLeaveBalanceAllOnce"
                      defaultMessage="Leave balance will be credited all at once"
                    />
                  </span>
                  {this.state.accuralfrequencytype == "2" ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                {/* </div> */}
              </div>
              <div className="inner-wrapper margin-top-20 opaque">
                <p className="form-main-header">
                  <FormattedMessage
                    id="LbUsagePolicy"
                    defaultMessage="Usage Policy"
                  />
                </p>
                <p className="form-sub-header">
                  <FormattedMessage
                    id="LbConfigureLeaveUsage"
                    defaultMessage="Now, let's configure the leave usage policy below"
                  />
                </p>
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbLeaveUsageLimits"
                    defaultMessage="Leave usage limits"
                  />
                </p>
                <FormattedMessage
                  id="LbAllowOnlyMin"
                  defaultMessage="Allow only a minimum of "
                />
                {/* <p> */}
                <InputValues
                  min="1"
                  max="24"
                  field="minhour"
                  onChange={this.CommonNumberChange.bind(this, "minhour", 24)}
                  value={this.state.minhour}
                  defaultvalue={this.state.minhour}
                  className="margin-right-8 margin-left-8"
                />
                <FormattedMessage
                  id="LbHoursInDay"
                  defaultMessage="hours leave in a day"
                />
                <div className="inner-wrapper opaque">
                  <div>
                    <FormattedMessage
                      id="LbMaximumHoursPerDay"
                      defaultMessage="Maximum hours allowed in one day"
                    />
                  </div>
                  <p>
                    <InputValues
                      min="1"
                      max="24"
                      field="maxonedayhour"
                      onChange={this.CommonNumberChange.bind(
                        this,
                        "maxonedayhour",
                        24,
                      )}
                      value={this.state.maxonedayhour}
                      defaultvalue={this.state.maxonedayhour}
                    />
                  </p>
                </div>
                {/* </p> */}
              </div>
              {/* <div className="inner-wrapper opaque margin-top-20">
                <p class="depedent-select-list-head">
                  <FormattedMessage
                    id="LbLimitFutureApplications"
                    defaultMessage="Do you want to limit leave applications for future dates?"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isfurtureappallowed", true)}
                  aria-expanded={this.state.isfurtureappallowed == true ? true : false}
                >
                  <span>
                    {" "}
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />{" "}
                  </span>
                  {this.state.isfurtureappallowed == true ? (
                    <span className="floatright">
                      {" "}
                      <img src={CheckImg} height="20" />{" "}
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div className="et-level2">
                  <Collapse
                    in={this.state.isfurtureappallowed}
                    timeout={2}
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <FormattedMessage
                      id="LbLeaveDurationGreater"
                      defaultMessage="If leave duration is greater than"
                    />
                    <InputValues
                      min="1"
                      max="365"
                      field="minleavecountforapp"
                      onChange={this.CommonNumberChange.bind(this, "minleavecountforapp", 365)}
                      value={this.state.minleavecountforapp}
                      defaultvalue={this.state.minleavecountforapp}
                    />
                    <span>days, </span>
                    <br />
                    <FormattedMessage
                      id="__LbApplicationMustBe"
                      defaultMessage="employee must apply for a leave  atleast"
                    />
                    <InputValues
                      min="1"
                      max="365"
                      field="notifyinadvanceday"
                      onChange={this.CommonNumberChange.bind(this, "notifyinadvanceday", 365)}
                      value={this.state.notifyinadvanceday}
                      defaultvalue={this.state.notifyinadvanceday}
                    />
                    <span>days in advance,</span>
                    <br />
                    <FormattedMessage
                      id="__LbButNotEarlier1"
                      defaultMessage="but not earlier than"
                    />
                    <InputValues
                      min={
                        this.state.notifyinadvanceday && parseInt(this.state.notifyinadvanceday) + 1
                      }
                      //   min={this.state.notifyinadvanceday && this.state.notifyinadvanceday}
                      max="365"
                      field="notifynotbeforeday"
                      onChange={this.CommonNumberChange.bind(this, "notifynotbeforeday", 365)}
                      value={this.state.notifynotbeforeday}
                      defaultvalue={this.state.notifynotbeforeday}
                    />

                    <FormattedMessage id="LbDays" defaultMessage="days" />
                  </Collapse>
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isfurtureappallowed", false)}
                  aria-expanded={this.state.isfurtureappallowed == false ? true : false}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {this.state.isfurtureappallowed == false ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected" />
                  )}
                </div>
              </div> */}
              {/* 4 */}
              <div className="inner-wrapper margin-top-20 opaque">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbPastApplications"
                    defaultMessage="Do you want to allow leave application for past dates?"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("ispastappallowed", true)}
                  aria-expanded={this.state.ispastappallowed == true}
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {this.state.ispastappallowed == true ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div className="et-level2">
                  <Collapse
                    in={this.state.ispastappallowed}
                    timeout={2}
                    unmountOnExit
                    className="padding20 overflow-initial"
                  >
                    <FormattedMessage
                      id="LbApplMadeUpTo"
                      defaultMessage="Leave application can be made upto"
                    />
                    <InputValues
                      min="1"
                      max="90"
                      field="apppastday"
                      onChange={this.CommonNumberChange.bind(
                        this,
                        "apppastday",
                        90,
                      )}
                      value={this.state.apppastday}
                      defaultvalue={this.state.apppastday}
                      classNames="margin-right-8 margin-left-8"
                    />

                    <FormattedMessage
                      id="LbActualLeaveDate"
                      defaultMessage="days after actual leave date"
                    />
                  </Collapse>
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("ispastappallowed", false)}
                  aria-expanded={this.state.ispastappallowed == false}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {this.state.ispastappallowed == false ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected" />
                  )}
                </div>
              </div>
              <div className="inner-wrapper margin-top-20 opaque">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbHowDoWeHandleLeave"
                    defaultMessage="How do we handle leave applications which exceed the available leave balance?"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() =>
                    this.handleChange("isoverutilizationallowed", true)
                  }
                  aria-expanded={!!this.state.isoverutilizationallowed}
                >
                  <span>
                    {" "}
                    <FormattedMessage
                      id="LbAllowLeave"
                      defaultMessage="Allow leave applications in excess of available balance"
                    />{" "}
                  </span>
                  {this.state.isoverutilizationallowed ? (
                    <span className="floatright">
                      {" "}
                      <img src={CheckImg} height="20" />{" "}
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() =>
                    this.handleChange("isoverutilizationallowed", false)
                  }
                  aria-expanded={!this.state.isoverutilizationallowed}
                >
                  <span>
                    {" "}
                    <FormattedMessage
                      id="LbDontAllowLeave"
                      defaultMessage="Don't allow leave applications in excess of available balance hours"
                    />{" "}
                  </span>
                  {!this.state.isoverutilizationallowed ? (
                    <span className="floatright">
                      {" "}
                      <img src={CheckImg} height="20" />{" "}
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
              </div>
              {this.RenderCarryForward()}
              <div className="inner-wrapper margin-top-20 opaque">
                <p className="form-main-header">
                  <FormattedMessage
                    id="LbApprovalWorkflow"
                    defaultMessage="Approval Workflow"
                  />
                </p>
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbHowDoYou"
                    defaultMessage="How do you want to process an application of Hourly Leave?"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("approvaltypeid", 1)}
                  aria-expanded={this.state.approvaltypeid == 1}
                >
                  <span>
                    {" "}
                    <FormattedMessage
                      id="LbFollowExisting"
                      defaultMessage="Follow existing Leave Approval Workflow"
                    />{" "}
                  </span>
                  {this.state.approvaltypeid == 1 ? (
                    <span className="floatright">
                      {" "}
                      <img src={CheckImg} height="20" />{" "}
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("approvaltypeid", 2)}
                  aria-expanded={this.state.approvaltypeid == 2}
                >
                  <span style={{ display: "inline-block", width: "97%" }}>
                    <FormattedMessage
                      id="LbBypassExisting"
                      defaultMessage="Bypass existing Leave Approval Workflow, directly send the hourly-leave application to Reporting Manager(s) for approval"
                    />
                  </span>
                  {this.state.approvaltypeid == 2 ? (
                    <span className="floatright">
                      {" "}
                      <img src={CheckImg} height="20" />{" "}
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("approvaltypeid", 3)}
                  aria-expanded={this.state.approvaltypeid == 3}
                >
                  <span>
                    {" "}
                    <FormattedMessage
                      id="LbAutoApprove"
                      defaultMessage="Auto-approve hourly leave applications and notify manager/admin"
                    />{" "}
                  </span>
                  {this.state.approvaltypeid == 3 ? (
                    <span className="floatright">
                      {" "}
                      <img src={CheckImg} height="20" />{" "}
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
              </div>
              {/* CarryForwardEncashment */}
              {/* <CarryForwardEncashment ParentIndex={this.state.ParentIndex} leavetypeid={this.state.leavetypeid} /> */}
              {/* CarryForwardEncashment */}
            </Grid>
          </Grid>
          {/* {this.state.ParentIndex !=
          this.props.InitLeavesPolicy.details.length - 1 ? (
            <Button
              className="margin-top-30"
              variant="contained"
              color="primary"
              onClick={() => this.validateNext()}
            >
              Next
            </Button>
          ) : (
            ""
          )} */}
        </div>
      </IntlProvider>
    );
  }
}

HourlyLeave.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(HourlyLeave)));
